/**
 * Badge — 状态标记（已翻译/已收藏/Pro 徽章）
 */

import { HTMLAttributes } from 'react';

export type BadgeVariant = 'default' | 'success' | 'warning' | 'info';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-border-warm dark:bg-border-warm-dark text-charcoal dark:text-charcoal-light',
  success: 'bg-oasis/15 text-oasis',
  warning: 'bg-camel/15 text-camel-dark dark:text-camel',
  info: 'bg-info/15 text-info',
};

export function Badge({
  variant = 'default',
  className = '',
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-sm px-1.5 py-0.5 text-xs font-medium ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}
